import {
  getChild,
  getProduct,
  getProductCategory,
  getIndexBody,
  getIndexSwiper,
  getSwiper,
  getNews,
  getNewsDetails,
  getCourse,
  getHonor
} from "../api/getData.js";

const actions = {
  // 获取产品分类
  getProductCategoryData(context, data) {
    return new Promise((resolve, reject) => {
      getChild(data).then(res => {
        if (res.StatusCode === 200) {
          //   context.commit("GET_PRODUCT_CATEGORY", res.Data);
          resolve(res.Data);
        } else {
          reject(res.Data);
        }
      });
    });
  },
  // 获取产品分类详情
  getProductCategoryDetails(context, data) {
    return new Promise((resolve, reject) => {
      getProductCategory(data).then(res => {
        if (res.StatusCode === 200) {
          resolve(res);
        } else {
          reject(res.Data);
        }
      });
    });
  },
  // 获取产品列表
  getProductList(context, data) {
    return new Promise((resolve, reject) => {
      getProduct(data).then(res => {
        if (res.StatusCode === 200) {
          resolve(res);
        } else {
          reject(res.Data);
        }
      });
    });
  },
  // 获取网页配置（首页的body）
  getIndexBodyData(context, data) {
    return new Promise((resolve, reject) => {
      getIndexBody(data).then(res => {
        if (res.StatusCode === 200) {
          if (data.Data.FInterID === 3) {
            context.commit("SET_CONTACT_US_DATA", res.Data);
          }
          resolve(res);
        } else {
          reject(res.Data);
        }
      });
    });
  },
  // 获取首页轮播
  getIndexSwiperData() {
    return new Promise((resolve, reject) => {
      getIndexSwiper().then(res => {
        if (res.StatusCode === 200) {
          resolve(res);
        } else {
          reject(res.Data);
        }
      });
    });
  },
  // 获取首页banner
  getIndexBanner() {
    return new Promise((resolve, reject) => {
      getSwiper().then(res => {
        if (res.StatusCode === 200) {
          resolve(res);
        } else {
          reject(res.Data);
        }
      });
    });
  },
  // 获取新闻列表
  getNewsList(context, data) {
    return new Promise((resolve, reject) => {
      getNews(data).then(res => {
        if (res.StatusCode === 200) {
          resolve(res);
        } else {
          reject(res.Data);
        }
      });
    });
  },
  // 获取新闻详情
  getNewsDetailsData(context, data) {
    return new Promise((resolve, reject) => {
      getNewsDetails(data).then(res => {
        if (res.StatusCode === 200) {
          resolve(res);
        } else {
          reject(res.Data);
        }
      });
    });
  },
  // 获取公司历程
  getCourseData(context, data) {
    return new Promise((resolve, reject) => {
      getCourse(data).then(res => {
        if (res.StatusCode === 200) {
          resolve(res);
        } else {
          reject(res.Data);
        }
      });
    });
  },
  // 获取荣誉
  getHonorData(context, data) {
    return new Promise((resolve, reject) => {
      getHonor(data).then(res => {
        if (res.StatusCode === 200) {
          resolve(res);
        } else {
          reject(res.Data);
        }
      });
    });
  }
};

export default actions;
